import { createSelector } from "reselect";
/**
 * Selects the permissions state slice.
 * @type {Selector<*, UIStateSlice>}
 */ export var uiSelector = function(state) {
    return state.ui;
};
export var notificationsSelector = createSelector(uiSelector, function(param) {
    var notifications = param.notifications;
    return notifications;
});
export var pendingRequestsSelector = createSelector(uiSelector, function(param) {
    var pendingRequests = param.pendingRequests;
    return pendingRequests;
});
export var openedModalSelector = createSelector(uiSelector, function(param) {
    var openedModal = param.openedModal;
    return openedModal;
});
export var getFormValue = createSelector(uiSelector, function(param) {
    var form = param.form;
    return form;
});
export var getCurrentSelectedTabValue = createSelector(uiSelector, function(param) {
    var currentSelectedTab = param.currentSelectedTab;
    return currentSelectedTab;
});

//# sourceMappingURL=selectors.js.map